import { useState } from "react";
import Button from "../../../../components/button/button";
import Tabs from "../../../../components/tabs/tabs";
import * as CSS from "./polls-module.styles";
import ActivePolls from "./sub-modules/active-polls/active-polls";
import CreatePoll from "./sub-modules/create-poll/create-poll";
import EndedPolls from "./sub-modules/ended-polls/ended-polls";

type TabIds = "active" | "ended";

const PollsModule = () => {
	const [activeTab, setActiveTab] = useState<TabIds>("active");
	const [creatingPoll, setCreatingPoll] = useState(false);

	if (creatingPoll) {
		return (
			<CSS.PollsModule>
				<CreatePoll onCancel={() => setCreatingPoll(false)} />
			</CSS.PollsModule>
		);
	}

	return (
		<CSS.PollsModule>
			<div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
				<Button
					onClick={() => setCreatingPoll(true)}
					style={{ whiteSpace: "nowrap", flexShrink: 0 }}
				>
					New poll
				</Button>
				<div style={{ flex: 1, minWidth: 0 }}>
					<Tabs
						activeTab={activeTab}
						onChange={(id) => setActiveTab(id as TabIds)}
						items={[
							{
								id: "active",
								label: "Active",
							},
							{
								id: "ended",
								label: "Ended",
							},
						]}
					/>
				</div>
			</div>
			{activeTab === "active" ? <ActivePolls /> : <EndedPolls />}
		</CSS.PollsModule>
	);
};

export default PollsModule;
